import type { RouteRecordRaw } from "vue-router";

export const assistantRoutes: RouteRecordRaw[] = [
  // AI Assistants (public)
  // Static routes must come before dynamic :id
  {
    path: "/ai/assistants",
    name: "ai-assistant-index-public",
    component: () => import("./assistants/AssistantListPage.vue"),
  },
  // Not a page: an assistant's entry URL, forwarded to `ai_chat-assistants-show`.
  // Ablage rows link it for the author; start-page and gallery tiles and the
  // sitemap link public assistants with `?public_token`. A record redirect, so
  // only the target enters history and Back leads to where the link was
  // (#13751). params, query and hash carry over, among them `public_token` and
  // the Ablage's `back_url`/`back_title` for the editor's breadcrumb (#13336);
  // naming a `query` here would replace them instead of merging.
  {
    path: "/ai/assistants/:id",
    name: "ai_assistant-show",
    redirect: { name: "ai_chat-assistants-show" },
  },
];
